/* POVA — chrome adapter.
 *
 * The wordmark and other fixed chrome (ticker, comp-number, reg-marks,
 * nav-pill) sit at the top of every page. In light mode they are dark;
 * in dark mode they are light. The problem: when a *dark* section scrolls
 * under the chrome (e.g. a .schematic-chapter showcase pill on a white
 * page), the dark wordmark vanishes against the dark surface.
 *
 * This script flips the chrome's apparent context when any dark-surface
 * element intersects the top of the viewport. We don't change the user's
 * theme preference — we just temporarily set data-chrome-context="dark"
 * on <html>, and the CSS treats the chrome as if the page is dark.
 *
 * Pattern: Apple's iPhone product pages, when a dark "moment" scrolls
 * under their fixed nav, swap the wordmark + nav text to white.
 *
 * Targets: any .schematic-chapter, .narrative-chapter, or element with
 * an explicit [data-chrome-context="dark"] attribute (escape hatch for
 * future dark sections).
 */
(function () {
  "use strict";

  var SELECTORS =
    ".schematic-chapter, .narrative-chapter, [data-chrome-context-trigger='dark']";
  var root = document.documentElement;

  function init() {
    var targets = document.querySelectorAll(SELECTORS);
    if (!targets.length) return;

    // Track which targets are intersecting the chrome zone (the strip at
    // the top of the viewport where the wordmark + nav-pill live).
    // rootMargin "0px 0px -90% 0px" collapses the IntersectionObserver
    // root to the top 10% of the viewport — anything entering that strip
    // triggers a context flip.
    var inChrome = new Set();

    function update() {
      if (inChrome.size > 0) {
        root.setAttribute("data-chrome-context", "dark");
      } else {
        root.removeAttribute("data-chrome-context");
      }
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) inChrome.add(e.target);
          else inChrome.delete(e.target);
        });
        update();
      },
      { rootMargin: "0px 0px -90% 0px", threshold: 0 }
    );

    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
